import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";

export default function SyncMonitorPage() {
  const { t } = useTranslation();
  const [data, setData] = useState({ operations: [], conflicts: [] });
  const [reason, setReason] = useState("");
  const load = () => api.get("/offline-sync/admin/monitor").then((response) => setData(response.data || { operations: [], conflicts: [] }));
  useEffect(() => { load().catch(() => setData({ operations: [], conflicts: [] })); }, []);
  const counts = useMemo(() => Object.fromEntries(["synced", "processing", "retrying", "failed", "review_required"].map((status) => [status, data.operations.filter((row) => row.status === status).length])), [data.operations]);
  const resolve = async (id, decision) => {
    if (!reason.trim()) return;
    await api.post(`/offline-sync/admin/conflicts/${id}/resolve`, { decision, reason: reason.trim() });
    setReason("");
    await load();
  };
  return <div className="space-y-5" data-testid="owner-sync-monitor">
    <div><div className="tiny-label">{t("offline.owner.eyebrow")}</div><h1 className="text-3xl font-bold">{t("offline.owner.title")}</h1><p className="text-muted-foreground">{t("offline.owner.help")}</p></div>
    <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
      {Object.entries(counts).map(([key, value]) => <Card key={key} className="p-4"><div className="text-xs text-muted-foreground break-words">{key.replace("_", " ")}</div><div className="text-2xl font-bold">{value}</div></Card>)}
    </div>
    <Card className="p-4 overflow-hidden">
      <h2 className="text-xl font-bold">{t("offline.owner.conflicts")}</h2>
      <div className="mt-3 space-y-3">
        {data.conflicts.length === 0 && <p className="text-sm text-muted-foreground">{t("offline.owner.none")}</p>}
        {data.conflicts.map((row) => <div key={row.id} className="rounded-xl border p-3 break-words">
          <div className="font-semibold">{row.module} · {row.action}</div>
          <div className="text-xs text-muted-foreground">{row.reason_code} · {row.local_timestamp || "—"}</div>
          {row.status === "open" && <div className="mt-3 space-y-2">
            <Input value={reason} onChange={(event) => setReason(event.target.value)} placeholder={t("offline.owner.reason")} />
            <div className="flex flex-wrap gap-2">
              <Button variant="outline" onClick={() => resolve(row.id, "accept_server")}>{t("offline.owner.keep_server")}</Button>
              <Button variant="outline" onClick={() => resolve(row.id, "reject_operation")}>{t("offline.owner.reject")}</Button>
              <Button onClick={() => resolve(row.id, "retry_operation")}>{t("offline.owner.retry")}</Button>
            </div>
          </div>}
        </div>)}
      </div>
    </Card>
  </div>;
}
